<p-confirmDialog />

<p-dialog
  [(visible)]="addDocDialogVisible"
  [modal]="true"
  [style]="{ width: '32rem' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="addDocPending = null"
>
  <ng-template pTemplate="header">
    <span i18n="@@skill-doc-add-header">Dokument hinzufügen</span>
  </ng-template>
  <div class="d-flex flex-column gap-3">
    <div>
      <label
        class="form-label fw-semibold"
        i18n="@@skill-trigger-label"
      >Wann soll der Bot diesen Skill nutzen?</label>
      <textarea
        pTextarea
        class="w-100"
        [(ngModel)]="addDocDescription"
        rows="3"
        i18n-placeholder="@@description-placeholder"
        placeholder="Beschreibe typische Fragen oder Situationen, in denen der Bot diesen Skill einsetzen soll."
      ></textarea>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      severity="secondary"
      [outlined]="true"
      i18n-label="@@cancel"
      label="Abbrechen"
      (onClick)="addDocDialogVisible = false; addDocPending = null"
    />
    <p-button
      [disabled]="!addDocDescription.trim()"
      i18n-label="@@add-doc-dialog-confirm"
      label="Hinzufügen"
      (onClick)="confirmAddDocument()"
    />
  </ng-template>
</p-dialog>

<h3 class="with-manual-link">
  <span i18n="@@documents">Dokumente</span>
  <app-manual-link
    href="https://reflact.github.io/engine/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Skills/Dokumente"></app-manual-link>
</h3>

<app-extraction-dialog
  [(visible)]="extractionDialogVisible"
  [doc]="extractionDialogDoc"
  (extracted)="onExtractionDone()"
/>

<div class="text-secondary mt-1 mb-1">
  <p
    class="mb-1"
    i18n="@@documents-description"
  >
    Lade eigene Dateien (PDF, Word, …) hoch – sie werden in Textabschnitte aufgeteilt und dem LLM bei Bedarf als Wissen
    übergeben. Einzelne Dokumente lassen sich jederzeit aktivieren oder deaktivieren. Die Daten fließen nicht in das
    Training des KI-Modells ein.
  </p>
  <p class="mb-0">
    Dokumente können über die
    <a
      href="#"
      [routerLink]="['/bot-admin','project', rss.botConfig.projectId ?? '-' ,'documents']"
    >
      Projekteinstellungen
    </a>
    verwaltet werden.
  </p>
</div>
<div class="row mt-3">
  <div class="col-12 col-lg-5 mb-3 mb-lg-0">
    <p-select
      #addSelector
      [options]="rss.selectableDocuments"
      placeholder="Dateien auswählen, auf die der Bot zugreifen soll"
      optionLabel="filename"
      display="chip"
      class="w-full"
      filter="true"
      filterBy="filename"
      (onChange)="addDocument($event); addSelector.clear()"
    />
  </div>

  <div class="col-12 col-lg-7">
    <div class="d-flex align-items-center gap-2 mb-2">
      <h6
        class="mb-0"
        i18n="@@documents-direct-upload-title"
      >Direkt im Bot hochladen</h6>
      <i
        class="ri-information-line text-muted"
        tooltip="Der Upload legt die Datei im Projekt an und fügt sie direkt dem Bot hinzu."
        i18n-tooltip="@@documents-direct-upload-description"
        placement="top"
      ></i>
      <input
        #directUploadInput
        type="file"
        class="d-none"
        [accept]="directUploadAccept"
        (change)="onDirectFileSelected($event)"
      />

      <div
        class="bot-direct-upload-dropzone"
        [class.dragging]="isDirectUploadDragging"
        [class.uploading]="isDirectUploadRunning"
        role="button"
        tabindex="0"
        (click)="!isDirectUploadRunning && directUploadInput.click()"
        (dragover)="onDirectDragOver($event)"
        (dragleave)="onDirectDragLeave($event)"
        (drop)="onDirectDrop($event)"
      >
        <i [class]="isDirectUploadRunning ? 'ri-loader-2-line rotate' : 'ri-add-line'"></i>
        <span i18n="@@documents-direct-upload-button">Datei hochladen</span>
      </div>
    </div>
  </div>
</div>

@if (this.rss.documents.length > 0) {
<h5
  class="mt-5"
  i18n="@@documents-overview"
>Dokumente im Überblick</h5>
}

@if (this.rss.documents.length > 0) {
<p-table
  dataKey="_id"
  [(selection)]="selectedDocuments"
  [value]="this.rss.documents"
  [rowHover]="true"
  styleClass="p-datatable-sm"
>
  <ng-template pTemplate="header">
    <tr>
      <th class="bot-selection-cell"><p-tableHeaderCheckbox ariaLabel="Alle auswählen" i18n-ariaLabel="@@bulk-select-all" /></th>
      <th i18n="@@status">Status</th>
      <th i18n="@@document">Dokument</th>
      <th i18n="@@skillid">Skill ID</th>
      <th i18n="@@skill-usage-column">Stage-Zuordnung</th>
      <th i18n="@@chunk-metadata">Metadaten</th>
      <th i18n="@@onoff">Aus/An</th>
      <th i18n="@@documents-publicly-reachable-header">Öffentlich erreichbar</th>
      <th i18n="@@actions">Aktionen</th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-doc
  >
    <tr>
      <td class="bot-selection-cell"><p-tableCheckbox [value]="doc" [ariaLabel]="doc.filename" /></td>
      <td style="width: 4rem;">
        @if(!this.isImage(doc.filename) && (doc.description === '' || doc.functionName === '')) {
        <i
          class="ri-error-warning-fill text-warning"
          tooltip="Dem Dokument fehlt Auslöser und/oder Funktionsname"
          i18n-tooltip="@@warning-missing-info"
        ></i>
        }
        @else {
        @if (doc.enabledForKnowledge) {
        <i class="ri-circle-fill text-primary"></i>
        }
        @if (!doc.enabledForKnowledge) {
        <i class="ri-circle-line text-secondary"></i>
        }
        }
      </td>
      <td>
        <span
          class="fakelink"
          (click)="openDocumentDetail(doc._id)"
          [tooltip]="this.displayFileName(doc.filename)"
        >
          {{ this.displayFileName(doc.filename, true) }}
        </span>
        @if(doc.extractionStatus === 'uploaded' && !isImage(doc.filename)) {
        <div class="mt-1 d-flex align-items-center gap-1">
          <p-tag
            severity="warn"
            value="Noch nicht extrahiert"
            i18n-value="@@extraction-status-uploaded"
          />
          <i
            class="ri-information-line text-muted"
            tooltip="Dieses Dokument wurde noch nicht extrahiert. Das Dokument kann vom Bot erst genutzt werden, wenn es im Projektbereich extrahiert wurde."
            i18n-tooltip="@@extraction-status-uploaded-hint-bot"
            placement="right"
          ></i>
        </div>
        }
        @if(doc.extractionStatus === 'extracting') {
        <div class="mt-1"><p-tag
            severity="info"
            value="Wird extrahiert…"
            i18n-value="@@extraction-status-extracting"
          /></div>
        }
        @if(doc.extractionStatus === 'failed') {
        <div class="mt-1"><p-tag
            severity="danger"
            value="Extraktion fehlgeschlagen"
            i18n-value="@@extraction-status-failed"
          /></div>
        }
      </td>
      <td style="width:250px">
        <app-skill-id-input
          [value]="doc.skillId"
          (changed)="doc.skillId = $event; this.saveDocument(doc._id)"
        ></app-skill-id-input>
      </td>
      <td>
        <app-skill-usage-list [skillId]="doc.skillId"></app-skill-usage-list>
      </td>
      <td style="width: 6rem;">
        <i
          class="ri-file-text-line me-1"
          [style.color]="doc.chunkDisplayConfig?.showFilename ? 'var(--p-green-500, #10b981)' : ''"
          [ngClass]="doc.chunkDisplayConfig?.showFilename ? '' : 'text-muted'"
          [tooltip]="doc.chunkDisplayConfig?.showFilename ? 'Dateiname wird weitergegeben' : 'Dateiname wird nicht weitergegeben'"
        ></i>
        <i
          class="ri-pages-line me-1"
          [style.color]="doc.chunkDisplayConfig?.showPageNumber ? 'var(--p-green-500, #10b981)' : ''"
          [ngClass]="doc.chunkDisplayConfig?.showPageNumber ? '' : 'text-muted'"
          [tooltip]="doc.chunkDisplayConfig?.showPageNumber ? 'Seitenzahl wird weitergegeben' : 'Seitenzahl wird nicht weitergegeben'"
        ></i>
        <i
          class="ri-percent-line"
          [style.color]="doc.chunkDisplayConfig?.showScore ? 'var(--p-green-500, #10b981)' : ''"
          [ngClass]="doc.chunkDisplayConfig?.showScore ? '' : 'text-muted'"
          [tooltip]="doc.chunkDisplayConfig?.showScore ? 'Score wird weitergegeben' : 'Score wird nicht weitergegeben'"
        ></i>
      </td>
      <td style="width: 0rem;">
        <p-toggleswitch
          [(ngModel)]="doc.enabledForKnowledge"
          (onChange)="this.saveDocument(doc._id, true)"
        ></p-toggleswitch>
      </td>
      <td style="width: 0rem;">
        <p-toggleswitch
          [(ngModel)]="doc.publiclyReachable"
          (onChange)="this.saveDocument(doc._id)"
        ></p-toggleswitch>
      </td>
      <td
        style="width: 2rem;"
        class="text-end"
      >
        <p-menu
          #menu
          appendTo="body"
          [model]="docContextMenu"
          [popup]="true"
        ></p-menu>
        <p-button
          (onClick)="openDocMenu($event, menu, doc)"
          [rounded]="true"
          [text]="true"
          severity="secondary"
          [raised]="true"
          icon="ri ri-more-2-fill"
        ></p-button>
      </td>
    </tr>
  </ng-template>
</p-table>
<app-bulk-action-bar [actions]="bulkActions" [count]="selectedDocuments.length" [allSelected]="allSelected"
  (selectAll)="toggleAll(true)" (clear)="selectedDocuments = []" />
}

<h3
  class="mt-5"
  i18n="@@active-doc-search-heading"
>Dokumentsuche</h3>
<div class="card border-0">
  <div class="card-body">
    <app-form-for-boolean
      [label]="this.activeDocSearchLabel"
      [(value)]="this.rss.botConfig.activeDocSearch"
      [colClass]="'col-3'"
      (valueChange)="this.rss.saveBotConfigField('activeDocSearch')"
    >
      <app-hint i18n="@@hint-active-doc-search">
        Sucht vor jeder LLM-Anfrage automatisch in aktiven Dokumenten und fügt relevante Inhalte als zusätzlichen
        Kontext hinzu.
      </app-hint>
    </app-form-for-boolean>
    @if (this.rss.botConfig.activeDocSearch) {
    <div class="row mt-3">
      <div class="col-3">
        <label
          class="form-label"
          i18n="@@active-doc-search-min-score"
        >Minimale Übereinstimmung (%)</label>
        <app-hint i18n="@@active-doc-search-min-score-hint">50 = niedrige Übereinstimmung, 100 = nur exakter
          Treffer</app-hint>
        <p-inputnumber
          [(ngModel)]="this.rss.botConfig.activeDocSearchMinScore"
          [min]="50"
          [max]="100"
          [step]="1"
          [showButtons]="true"
          (ngModelChange)="this.rss.saveBotConfigField('activeDocSearchMinScore')"
        ></p-inputnumber>
      </div>
      <div class="col-3">
        <label
          class="form-label"
          i18n="@@active-doc-search-count"
        >Anzahl Ergebnisse</label>
        <p-inputnumber
          [(ngModel)]="this.rss.botConfig.activeDocSearchCount"
          [min]="1"
          [max]="20"
          [showButtons]="true"
          (ngModelChange)="this.rss.saveBotConfigField('activeDocSearchCount')"
        ></p-inputnumber>
      </div>
      <div class="col-3">
        <label
          class="form-label"
          i18n="@@active-doc-search-type"
        >Suchtyp</label>
        <app-hint>
          <b>Vektor:</b> Semantische Suche über KI-Embeddings – findet inhaltlich Ähnliches auch ohne exakte
          Stichwörter. Schnellste Methode.<br><br>
          <b>Volltext:</b> Keyword-Suche mit Fuzzy-Matching – treffsicher bei exakten Begriffen, kein semantisches
          Verständnis. Langsamer als Vektor.<br><br>
          <b>Kombiniert:</b> Vereint beide Methoden für beste Ergebnisqualität – am langsamsten.<br><br>
          Empfehlung: Ausprobieren, welche Methode für deinen Bot die besten Ergebnisse liefert.
        </app-hint>
        <p-select
          [options]="searchTypeOptions"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="this.rss.botConfig.activeDocSearchType"
          (ngModelChange)="this.rss.saveBotConfigField('activeDocSearchType')"
          fluid
        ></p-select>
      </div>
    </div>
    <div class="mt-3">
      <app-form-for-boolean
        [label]="this.activeDocSearchMemoryLabel"
        [(value)]="this.rss.botConfig.activeDocSearchMemoryEnabled"
        [colClass]="'col-3'"
        (valueChange)="this.rss.saveBotConfigField('activeDocSearchMemoryEnabled')"
      >
        <app-hint i18n="@@hint-active-doc-search-memory">
          Merkt sich Ergebnisse vergangener aktiver Dokumentsuchen im Gespräch, damit Wissen aus früheren
          Suchen bei späteren Nachrichten erhalten bleibt.
        </app-hint>
      </app-form-for-boolean>
    </div>
    @if (this.rss.botConfig.activeDocSearchMemoryEnabled) {
    <div class="row mt-3">
      <div class="col-3">
        <label
          class="form-label"
          i18n="@@doc-search-memory-limit"
        >Anzahl gemerkter Suchen</label>
        <app-hint i18n="@@doc-search-memory-limit-hint">Ältere Suchen werden nicht verworfen, sondern automatisch
          zusammengefasst.</app-hint>
        <p-inputnumber
          [(ngModel)]="this.rss.botConfig.activeDocSearchMemoryLimit"
          [min]="1"
          [max]="10"
          [showButtons]="true"
          (ngModelChange)="this.rss.saveBotConfigField('activeDocSearchMemoryLimit')"
        ></p-inputnumber>
      </div>
    </div>
    }
    <div class="mt-4">
      <h6 i18n="@@active-doc-search-test-heading">Suche testen</h6>
      <p-multiselect
        class="d-block mb-3"
        [(ngModel)]="activeDocSearchTestDocs"
        [options]="rss.documents"
        optionLabel="filename"
        placeholder="Dokumente auswählen…"
        i18n-placeholder="@@active-doc-search-select-placeholder"
        display="chip"
        appendTo="body"
      />
      <p-inputgroup class="mb-3">
        <input
          pInputText
          [(ngModel)]="activeDocSearchTestPhrase"
          [disabled]="activeDocSearchTestRunning"
          placeholder="Suchanfrage eingeben…"
          i18n-placeholder="@@search-placeholder-doc"
        />
        <p-button
          [style]="{ 'border-top-left-radius': '0', 'border-bottom-left-radius': '0' }"
          (onClick)="runActiveDocSearchTest()"
          [disabled]="activeDocSearchTestRunning || activeDocSearchTestDocs.length === 0"
          [loading]="activeDocSearchTestRunning"
          label="Suchen"
          i18n-label="@@active-doc-search-run"
        />
      </p-inputgroup>
      @if (activeDocSearchTestCompleted && activeDocSearchTestResults.length === 0) {
      <p-message
        severity="warn"
        [closable]="false"
      >
        <span i18n="@@no-search-results">Keine Ergebnisse gefunden.</span>
      </p-message>
      }
      @if (activeDocSearchTestCompleted && activeDocSearchTestResults.length > 0) {
      <p-table
        [value]="activeDocSearchTestResults"
        [rowHover]="true"
        styleClass="p-datatable-sm mt-3"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Score</th>
            <th i18n="@@document">Dokument</th>
            <th i18n="@@pages">Seiten</th>
            <th i18n="@@search-test-chapter-column">Kapitel</th>
            <th i18n="@@content">Inhalt</th>
          </tr>
        </ng-template>
        <ng-template
          pTemplate="body"
          let-result
        >
          <tr>
            <td style="white-space: nowrap;">{{ result.chunk.vs_score * 100 | number:"2.2-2" }}%</td>
            <td>{{ result.document.filename }}</td>
            <td style="white-space: nowrap;">
              @if (result.chunk.first_page === result.chunk.last_page) {
              {{ result.chunk.first_page }}
              } @else {
              {{ result.chunk.first_page }} – {{ result.chunk.last_page }}
              }
            </td>
            <td>{{ result.chunk.chapterPath ?? '–' }}</td>
            <td>{{ result.chunk.content }}</td>
          </tr>
        </ng-template>
      </p-table>
      }
    </div>
    }
  </div>
</div>

@if (detailDrawer) {
<p-drawer
  [(visible)]="this.detailDrawer"
  [position]="'right'"
  [modal]="true"
  [closeOnEscape]="true"
  styleClass="w-100 w-md-75 w-lg-50"
>
  @if (this.selectedDocumentId) {
  <app-documents-tab-detail
    [selectedDocumentId]="this.selectedDocumentId"
    (closeDrawer)="this.detailDrawer = false"
  ></app-documents-tab-detail>
  }
</p-drawer>
}